import { Card } from "antd";
import {
  Building2,
  GraduationCap,
  Users,
  BookOpen,
  CloudSun,
  MapPin,
  Shield,
  DollarSign,
} from "lucide-react";
import "./CollegeHighlights.css";

export const CollegeHighlights = ({ data }) => {
  if (!data) return null;
  const { City, Total_Programs, Highlights } = data;

  return (
    <Card className="college-highlights-card">
      <div className="college-highlights-header">
        <h2 className="college-highlights-title">College Highlights</h2>
      </div>
      <div className="college-highlights-content">
        <div className="highlights-grid">
          <div className="highlight-item">
            <div className="highlight-icon-container">
              <Building2 className="highlight-icon" />
            </div>
            <div>
              <h3 className="highlight-title">College Type</h3>
              <p className="highlight-description">{Highlights.College_Type}</p>
            </div>
          </div>

          <div className="highlight-item">
            <div className="highlight-icon-container">
              <GraduationCap className="highlight-icon" />
            </div>
            <div>
              <h3 className="highlight-title">Programs Offered</h3>
              <p className="highlight-description">{Total_Programs}</p>
              <div className="highlight-tags">
                {/* {data.programTags.map((tag, index) => (
                  <span key={index} className="highlight-tag">
                    {tag}
                  </span>
                ))} */}
              </div>
            </div>
          </div>

          <div className="highlight-item">
            <div className="highlight-icon-container">
              <Users className="highlight-icon" />
            </div>
            <div>
              <h3 className="highlight-title">Student Population</h3>
              <p className="highlight-description">
                {Highlights.Student_Population.Students} {" Students"}
              </p>
              <p className="highlight-subtext">
                {Highlights.Student_Population.Undergraduate} {" Undergraduate"}
              </p>
              <p className="highlight-subtext">
                {Highlights.Student_Population.Graduate}
                {" Graduate"}
              </p>
            </div>
          </div>

          <div className="highlight-item">
            <div className="highlight-icon-container">
              <BookOpen className="highlight-icon" />
            </div>
            <div>
              <h3 className="highlight-title">Class Size & Diversity</h3>
              <p className="highlight-description">
                {Highlights.Class.SFRatio} {" Student-Faculty Ratio"}
              </p>
              <p className="highlight-subtext">
                {Highlights.Class.International_Student}{" "}
                {"International Students"}
              </p>
            </div>
          </div>

          <div className="highlight-item">
            <div className="highlight-icon-container">
              <CloudSun className="highlight-icon" />
            </div>
            <div>
              <h3 className="highlight-title">Weather</h3>
              <p className="highlight-description">{Highlights.Weather.type}</p>
              <p className="highlight-subtext">
                {"Avg. Summer :"} {Highlights.Weather.Avg_Summer}
              </p>
              <p className="highlight-subtext">
                {"Avg. Winter :"} {Highlights.Weather.Avg_Winter}
              </p>
            </div>
          </div>

          <div className="highlight-item">
            <div className="highlight-icon-container">
              <MapPin className="highlight-icon" />
            </div>
            <div>
              <h3 className="highlight-title">Location</h3>
              <p className="highlight-description">{City}</p>
              {Highlights.Location.map((location, index) => (
                <p key={index} className="highlight-subtext">
                  {location}
                </p>
              ))}
            </div>
          </div>

          <div className="highlight-item">
            <div className="highlight-icon-container">
              <Shield className="highlight-icon" />
            </div>
            <div>
              <h3 className="highlight-title">Safety Rating</h3>
              <p className="highlight-description">
                {Highlights.Safety_Rating}
              </p>
              {/* <p className="highlight-subtext">{data.safetyDetail1}</p>
              <p className="highlight-subtext">{data.safetyDetail2}</p> */}
            </div>
          </div>

          <div className="highlight-item">
            <div className="highlight-icon-container">
              <DollarSign className="highlight-icon" />
            </div>
            <div>
              <h3 className="highlight-title">Cost of Living</h3>
              {Highlights.Cost_Of_Living.map((item, index) => (
                <p
                  key={index}
                  className={
                    index === 0 ? "highlight-description" : "highlight-subtext"
                  }
                >
                  {item}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};
